module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/msysov1-99a752fd4161183bf1414acd74e211ae.jpg";